import { render, staticRenderFns } from "./LoanCalculator2.vue?vue&type=template&id=1edd49d7&scoped=true"
import script from "./LoanCalculator2.vue?vue&type=script&lang=js"
export * from "./LoanCalculator2.vue?vue&type=script&lang=js"
import style0 from "./LoanCalculator2.vue?vue&type=style&index=0&id=1edd49d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd49d7",
  null
  
)

export default component.exports